import { useEffect } from "react";
import Modal from "./components/Modal";

import { applyFontFromConfig, font } from "./configs";

import "./App.css";

function App() {
  useEffect(() => {
    applyFontFromConfig(font);
  }, []);

  return <Modal />;
}

export default App;
